<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
        <c-header-nav class="d-none d-md-flex header-nav-tabs">

            <c-nav-item>
                <a routerLink="./" 
                   routerLinkActive="active" 
                   [routerLinkActiveOptions]="{ exact: true }" 
                   cNavLink>Depot Live Summary</a>
            </c-nav-item>
            
            <c-nav-item>
                <a routerLink="./downtime" 
                   routerLinkActive="active" 
                   [routerLinkActiveOptions]="{ exact: false }" 
                   cNavLink>Repairer Downtime</a>
            </c-nav-item>
            
            <!-- <c-nav-item>
                <a routerLink="/region/1/dpd-guildford/insights" 
                   routerLinkActive="active" 
                   [routerLinkActiveOptions]="{ exact: false }" 
                   cNavLink>Depot Insights & Predictions</a>
            </c-nav-item> -->
            
            <c-nav-item>
                <a routerLink="./unutilised" 
                   routerLinkActive="active" 
                   [routerLinkActiveOptions]="{ exact: false }" 
                   cNavLink>Most Frequent Unused</a>
            </c-nav-item>
            
          
        </c-header-nav>
</ng-container>
<!--</c-header>-->

